import { InterstateOnChangeEvent } from "@interstate/components/InterstateEvents";
import {
  SelectInput,
  SelectInputEventValue
} from "@interstate/components/SelectInput";
import { useEffect, useState } from "react";
import { usePhoneReply } from "../context";
import { replyCallTypeDropDownTestId } from "../testIds";
import { ConversationDirection } from "@coxauto-ui/cxm/communications/interfaces";

/* eslint-disable-next-line */
export interface MessageCallTypeInputProps {}

export function MessageCallTypeInput(props: MessageCallTypeInputProps) {
  const { messageCallType, setMessageCallType } = usePhoneReply();
  const [callType, setCallType] = useState(ConversationDirection.Outbound);

  useEffect(() => {
    if (callType !== messageCallType) setMessageCallType(callType);
  }, [callType, messageCallType, setMessageCallType]);

  const onSelectedInputChange = (
    e: InterstateOnChangeEvent<SelectInputEventValue>
  ) => {
    const direction =
      e.target.value === ConversationDirection.Inbound
        ? ConversationDirection.Inbound
        : ConversationDirection.Outbound;

    setCallType(direction);
    setMessageCallType(direction);
  };

  return (
    <SelectInput
      required
      data-testid={replyCallTypeDropDownTestId}
      displayDeselectOption={false}
      id="messageCallTypeInput"
      label="Call Type"
      name="CallType"
      options={[
        {
          label: "Inbound",
          value: ConversationDirection.Inbound
        },
        {
          label: "Outbound",
          value: ConversationDirection.Outbound
        }
      ]}
      value={callType}
      onChange={onSelectedInputChange}
    />
  );
}

export default MessageCallTypeInput;
